export default [
    {
        path: '/term-tags',
        name: 'term-tags',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Tag dos Termos',
            icon: 'mdi-code-tags-check',
            breadcrumbs: [
                { text: 'Lista de tags', disabled: true }
            ]
        }
    }
]